import { getRefundChildIds } from './refundPassengerUtils';
/**
 * Выбранные пассажиры, сгруппированные по семейным связям.
 * - Выбран взрослый с детьми → одна семья (adult, children, children, ...).
 * - Выбран только ребенок → отдельная запись.
 * - Выбран взрослый → отдельная запись.
 */
export const getSelectedRefundFamiliesFromPassengers = (passengers) => {
    var _a, _b;
    const families = [];
    const processedChildIds = new Set();
    for (const passenger of passengers) {
        if (processedChildIds.has(passenger.id)) {
            continue;
        }
        if (passenger.isSelected && ((_a = passenger.children) === null || _a === void 0 ? void 0 : _a.length)) {
            families.push(passenger);
            getRefundChildIds(passenger).forEach(childId => processedChildIds.add(childId));
            continue;
        }
        if (!((_b = passenger.children) === null || _b === void 0 ? void 0 : _b.length) && passenger.isSelected) {
            families.push(passenger);
        }
    }
    return families;
};
